import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { KYMW6000Component } from './kymw6000.component';
import { GetFeatureThemaListService } from './api-services/get-feature-thema-list.service';
import { GetCwsPlanGoodsUseImageGroupDispListService } from './api-services/get-cws-plan-goods-use-image-group-disp-list.service';


/**
 * EC使用画像一覧表画面 モジュール設定クラス
 *
 * @export KYMW6000Module
 * @class KYMW6000Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
  ],
  declarations: [
    KYMW6000Component,
  ],
  providers: [
    GetFeatureThemaListService,
    GetCwsPlanGoodsUseImageGroupDispListService,
  ],
})
export class KYMW6000Module {

}
